import { GetServerSidePropsContext, InferGetServerSidePropsType } from "next";
import {
  BreadcrumbJsonLd,
  CarouselJsonLd,
  CollectionPageJsonLd,
} from "next-seo";
import Layout from "~/layouts/ThemeLayout";
import SEOTags from "~/components/SEOTags";
import { PATH, SectionsKey } from "~/constants/enum";
import { GET_PRODUCT_COLLECTIONS } from "~/data/collections";
import { UseCollectionResponse } from "~/data/collections/interface";
import useRenderComponent from "~/hooks/useRenderComponent";
import { initializeApollo } from "~/utils/apollo-client";
import { parseVarFormCmsBlock } from "~/utils/converters";
import { getUrlByTheme } from "~/utils/theme";

const Collections = ({
  collections,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const newCollections =
    collections?.map((collection) => {
      const type = parseVarFormCmsBlock(collection?.description || "");
      const { typeCollection } = type;
      return {
        ...collection,
        typeCollection,
      };
    }) || [];

  const collectionSectionDataHandler = (type: SectionsKey) => {
    return newCollections.filter(
      (collection) => collection?.typeCollection === type
    );
  };

  const { render } = useRenderComponent<any>({
    fileName: "collections",
    sectionData: {
      [SectionsKey.CollectionsAbout]: {
        collections: collectionSectionDataHandler(SectionsKey.CollectionsAbout),
      },
      [SectionsKey.Collections]: {
        collections: collectionSectionDataHandler(SectionsKey.Collections),
      },
      [SectionsKey.CollectionsRecommend]: {
        collections: collectionSectionDataHandler(
          SectionsKey.CollectionsRecommend
        ),
      },
    },
  });

  const itemListElements = [
    {
      position: 1,
      name: "Home",
      item: process.env.NEXT_PUBLIC_URL + "",
    },
    {
      position: 2,
      name: "Collections",
      item: getUrlByTheme(PATH.Collections),
    },
  ];
  return (
    <Layout>
      <SEOTags title="Collections" />
      {<BreadcrumbJsonLd itemListElements={itemListElements} />}
      {!!collections?.length && (
        <CarouselJsonLd
          ofType="default"
          data={collections?.map((i) => {
            return {
              name: i?.name,
              url: getUrlByTheme(
                PATH.CollectionDetail.replace("[slug]", i?.url_key)
              ),
            };
          })}
        />
      )}

      <div className="py-10">{render()}</div>
    </Layout>
  );
};

export default Collections;

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.query<UseCollectionResponse>({
    query: GET_PRODUCT_COLLECTIONS,
  });

  const { ProductCollectionList } = data || {};

  return {
    props: {
      collections: ProductCollectionList,
    },
  };
};
